export default "/images/close.svg?49373796fcfbb1dc10abc7aafd752f5f";